import Vue from 'vue'
export const EventBus = new Vue({
  methods: {
    setPrevHeight () {
      document.getElementById("app").$prevHeight = document.getElementById("app").clientHeight + "px";
    }
  }
})



// WEBPACK FOOTER //
// ./src/utils/event-bus.js